import CustomTextArea from "components/Form/TeaxtAreaBootstrap";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

type DetailsAndCommentsProps = { control; errors };
const DetailsAndCommentsTextArea = ({
  control,
  errors,
}: DetailsAndCommentsProps) => {
  const { t } = useTranslation();
  return (
    <Row className="text-area-decision-container default-vertical-padding">
      <Col>
        <Controller
          name="detailsAndAdditionalComments"
          control={control}
          render={({ field: { onChange } }) => (
            <CustomTextArea
              name="detailsAndAdditionalComments"
              control={control}
              errors={errors}
              label={t("detailsAndAdditionalComments")}
              required={false}
              maxLength={240}
            />
          )}
        />
      </Col>
    </Row>
  );
};

export default DetailsAndCommentsTextArea;
